export const INQUIRY_COPY_DRAFT_VERSION = 2;

export const getCopiedInquiryInitialValues = (inquiry: any) => ({
    startCountry: String(inquiry?.start_country_id ?? ''),
    startCity: inquiry?.start_city ?? '',
    destinationCountry: String(inquiry?.destination_country_id ?? ''),
    destinationCity: inquiry?.destination_city ?? '',
    service: String(inquiry?.service_id ?? ''),
    user: String(inquiry?.user_id ?? '0'),
    client: inquiry?.client?.name ?? '',
    clientContact: String(inquiry?.client_contact_id ?? ''),
    comment: inquiry?.comment ?? '',
    amount: inquiry?.amount ?? '',
    weight: inquiry?.weight ?? '',
    noWeight: inquiry?.no_weight === 1,
    _copySourceId: String(inquiry?.id ?? ''),
    _copyDraftVersion: INQUIRY_COPY_DRAFT_VERSION,
    _hydrated: true,
});

export const isInquiryCopyDraftForSource = (draft: any, sourceId: string) =>
    draft?._copySourceId === sourceId
    && draft?._copyDraftVersion === INQUIRY_COPY_DRAFT_VERSION;
